import { render, staticRenderFns } from "./StandardLayout.vue?vue&type=template&id=0117da38&scoped=true&"
import script from "./StandardLayout.vue?vue&type=script&lang=ts&"
export * from "./StandardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StandardLayout.vue?vue&type=style&index=0&id=0117da38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0117da38",
  null
  
)

export default component.exports